import React from 'react';

export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="relative overflow-hidden border-b border-border/60">
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-10 opacity-80 pointer-events-none"
        style={{
          background: 'radial-gradient(40% 50% at 20% 10%, rgba(42,125,95,0.06), transparent 60%), radial-gradient(40% 50% at 80% 0%, rgba(30,110,82,0.06), transparent 60%)',
        }}
      />
      <div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div className="space-y-2 max-w-2xl">
          {eyebrow && (
            <p className="text-[11px] uppercase tracking-[0.22em] font-semibold" style={{ color: 'var(--primary)' }}>
              {eyebrow}
            </p>
          )}
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight" style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif" }}>
            {title}
          </h1>
          {description && (
            <p className="text-sm text-muted-foreground">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
